// Servicios para suscripciones en tiempo real

import { supabase } from '../../supabaseClient';

/**
 * Suscribirse a cambios en ofertas de una propiedad
 */
export const subscribeToBids = (propertyId, callback) => {
  const subscription = supabase
    .channel(`bids:${propertyId}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'bids',
        filter: `property_id=eq.${propertyId}`,
      },
      (payload) => {
        callback({
          id: payload.new.id,
          propertyId: payload.new.property_id,
          buyerName: payload.new.buyer_name,
          buyerEmail: payload.new.buyer_email,
          amount: parseFloat(payload.new.amount),
          timestamp: payload.new.bid_time,
          conditionsText: payload.new.conditions_text,
          is_last_chance: payload.new.is_last_chance || false,
        });
      }
    )
    .subscribe();

  return subscription;
};

/**
 * Cancelar suscripción
 */
export const unsubscribe = (subscription) => {
  if (subscription) {
    supabase.removeChannel(subscription);
  }
};

/**
 * Suscribirse a cambios en ofertas ciegas de una propiedad
 * Escucha tanto INSERT como UPDATE para detectar verificaciones
 */
export const subscribeToBlindOffers = (propertyId, callback) => {
  const subscription = supabase
    .channel(`blind_offers:${propertyId}`)
    .on(
      'postgres_changes',
      {
        event: '*', // INSERT, UPDATE, DELETE
        schema: 'public',
        table: 'blind_offers',
        filter: `property_id=eq.${propertyId}`,
      },
      (payload) => {
        // Solo notificar si el evento es INSERT o UPDATE
        if (payload.eventType === 'INSERT' || payload.eventType === 'UPDATE') {
          callback({
            id: payload.new.id,
            propertyId: payload.new.property_id,
            inviteId: payload.new.invite_id,
            buyerName: payload.new.buyer_name,
            buyerEmail: payload.new.buyer_email,
            amount: parseFloat(payload.new.amount),
            conditionsText: payload.new.conditions_text,
            semaphoreStatus: payload.new.semaphore_status,
            isVerified: payload.new.is_verified,
            createdAt: payload.new.created_at,
            updatedAt: payload.new.updated_at,
            verifiedAt: payload.new.verified_at,
          });
        }
      }
    )
    .subscribe();

  return subscription;
};

/**
 * Suscribirse a cambios en una propiedad específica
 */
export const subscribeToProperty = (propertyId, callback) => {
  const subscription = supabase
    .channel(`property:${propertyId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'properties',
        filter: `id=eq.${propertyId}`,
      },
      (payload) => {
        callback(payload.new);
      }
    )
    .subscribe();

  return subscription;
};